module.exports = "\r\n<ul class=\"list-group\">\r\n  <li class=\"list-group-item\" [ngClass]=\"{'list-group-item-success': stat.highlighted}\"  *ngFor=\"let stat of stats\" >\r\n    <app-individual-stat [stat]=\"stat\" class=\"justify-content-between\"></app-individual-stat>\r\n  </li>\r\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./src/app/character/character-sheet/character-sheet-mechanics/stat-grid/stat-grid.component.html
// module id = ./src/app/character/character-sheet/character-sheet-mechanics/stat-grid/stat-grid.component.html
// module chunks = main